<!--  Edit stake numbers modal -->
<ion-modal
	class="edit-stake-modal"
	[isOpen]="editStakeModalService.isQuickBetAmountsEditModalVisible"
	(didDismiss)="editStakeModalService.dismissQuickBetAmountsEditModal()">
	<ng-template>
		<div class="wrapper">
			<div class="edit-stake-modal__header">
				<h3>{{ 'Set Button Value' | translate }}</h3>
				<button type="button" (click)="editStakeModalService.dismissQuickBetAmountsEditModal()" aria-label="Close stake edit modal">
					<ion-icon name="close"></ion-icon>
				</button>
			</div>

			<form [formGroup]="editFixedStakeValuesForm" (ngSubmit)="submitForm()" novalidate>
				<div class="edit-stake-modal__tabs">
					<button type="button" class="is-active">{{ 'Game Buttons' | translate }}</button>
				</div>

				<div class="edit-stake-modal__labels">
					<strong>{{ 'Price Label' | translate }}:</strong>
					<strong>{{ 'Price Value' | translate }}:</strong>
				</div>

				<div class="edit-stake-modal__grid" formArrayName="quickBetAmounts">
					@for (control of quickBetAmountControls; track $index) {
						<input type="text" [value]="formatPriceLabel(control.value)" readonly />
						<input type="text" [formControlName]="$index" />
					}
				</div>

				@if (formControls.quickBetAmounts.errors?.['lessThanZero']) {
					<p class="error-message">{{ 'Greater than zero' | translate }}</p>
				}
				@if (formControls.quickBetAmounts.errors?.['forbiddenCharactersUsed']) {
					<p class="error-message">{{ 'Allowed Characters' | translate }}</p>
				}

				<button class="edit-stake-modal__submit" type="submit" [disabled]="editFixedStakeValuesForm.invalid || isSubmitting">
					{{ 'Update' | translate }}
				</button>
			</form>
		</div>
	</ng-template>
</ion-modal>
